import { createId } from '@paralleldrive/cuid2';

export class Storage<T extends any> {
  private queue: T[] = [];

  constructor() {}

  add(data: T) {
    this.queue.push(data);
  }

  size() {
    return this.queue.length;
  }

  getStorageData() {
    return this.queue;
  }

  async drain(
    cb: (drainProcess: { items: T[]; transactionId: string }) => Promise<void> | void,
    count?: number,
  ) {
    const transactionId = createId();

    let stageItems: typeof this.queue = [];
    if (count) {
      stageItems = this.queue.splice(0, count);
    } else {
      stageItems = this.queue;
      this.queue = [];
    }

    try {
      await cb({ items: stageItems, transactionId });
    } catch (e) {
      this.queue = [...stageItems, ...this.queue];
    }

    return transactionId;
  }
}
